"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TagManager = _interopRequireDefault(require("./TagManager"));
var _default = exports.default = _TagManager.default;